import React from 'react';
import * as S from '../SeatWithTooltip/SeatWithTooltip.styles';
import Icon from '../../../stories/core-components/IconsSelector';

type SeatProps = {
  seatnumber?: string;
  seatprice?: string;
  sleepericon?: boolean;
  seatericon?: boolean;
  styleProps?: {
    [k: string]: string; // better typescript – 🐨 css properties
  };
  onSeatClick?: any;
  iconName?: string;
  verticalSleeper?: boolean;
};

const SeatWithTooltip = (props: SeatProps) => {
  const {
    seatnumber,
    seatprice,
    styleProps,
    sleepericon,
    seatericon,
    onSeatClick,
    iconName,
    verticalSleeper,
  } = props;
  return (
    <div onClick={onSeatClick}>
      {(sleepericon && (
        <S.BusSleeper {...styleProps}>
          <S.Tooltip>
            <span className="arrow"></span>
            <span className="tooltipTxt">
              <span className="seatNum">{seatnumber}</span>
              <span className="seatPrice">{seatprice}</span>
            </span>
          </S.Tooltip>
          {(verticalSleeper && (
            <Icon name={iconName} styleProps={{transform: 'rotate(-90deg)'}} />
          )) || <Icon name={iconName} />}
        </S.BusSleeper>
      )) ||
        ''}

      {(seatericon && (
        <S.BusSeat {...styleProps}>
          <S.Tooltip>
            <span className="arrow"></span>
            <span className="tooltipTxt">
              <span className="seatNum">{seatnumber}</span>
              <span className="seatPrice">{seatprice}</span>
            </span>
          </S.Tooltip>
          <Icon name={iconName} />
        </S.BusSeat>
      )) ||
        ''}
    </div>
  );
};

export default SeatWithTooltip;
